import { useCallback } from 'react';
import { usePanelStateAtom } from './rules-state/use-panel-state-atom';
import { useA11yWizardAdapter } from './use-a11y-wizard-adapter';
export const useNavigation = () => {
  const {
    a11yWizardAdapter
  } = useA11yWizardAdapter();
  const {
    getPagesData
  } = usePanelStateAtom();
  const navigateToPage = useCallback((pageId, routerId) => {
    var _pageData$innerRoutes;
    const pageData = getPagesData().get(pageId ?? '');
    if (!routerId && a11yWizardAdapter.getCurrentPageId() !== pageId) {
      a11yWizardAdapter.moveToPage(pageId);
      return;
    }
    const pageUrl = pageData == null || (_pageData$innerRoutes = pageData.innerRoutes) == null || (_pageData$innerRoutes = _pageData$innerRoutes.find(innerRoute => innerRoute.id === routerId)) == null ? void 0 : _pageData$innerRoutes.path;
    a11yWizardAdapter.moveToPage(pageId, pageUrl ? `.${pageUrl}` : undefined);
  }, [a11yWizardAdapter, getPagesData]);
  return navigateToPage;
};
//# sourceMappingURL=use-navigation.js.map